import Login from "../pages/login"

const AuthRouter: React.FC = () => {
  return <Login />
}

export default AuthRouter;